import { Component } from '@angular/core';

@Component({
  selector: 'app-remove-icon',
  imports: [],
  templateUrl: './remove-icon.component.html'
})
export class RemoveIconComponent {
}
